module.exports = __webpack_public_path__ + "static/img/mall_tab_icon_7_2.b50772d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mall/mall_tab_icon_7_2.png
// module id = 5qc5
// module chunks = 0